import React, { useState, useRef, useEffect } from "react";
import useDrop from "../../../hooks/useDrop";
import { useTranslation } from 'react-i18next';

const defaultLabel = "Select option";

const DropDown = ({
  category,
  listTitle,
  list,
  changeFunction,
  submitClick,
  className
}) => {
  const { t } = useTranslation();
  const blockRef = useRef();
  const [state, setState] = useState(defaultLabel);
  const [active, setActive] = useDrop(blockRef);

  useEffect(() => {
    if (changeFunction) {
      changeFunction(state);
    }
  }, [state]);

  useEffect(() => {
    setState(() => (listTitle ? listTitle : defaultLabel));
  }, [listTitle, list]);

  const handleClick = (el) => () => {
    setState(el);
    setActive(false);
    if (submitClick) {
      submitClick(el);
    }
  };
  const handleSwitch = () => {
    setActive((prevState) => !prevState);
  };
  const condition = active ? "active_drop" : "";
  return (
    <div className={`form-control ${className}`} ref={blockRef}>
      <label htmlFor="category">{category}</label>
      <div className="drop-down drop-down-user category">
        <div className="drop-down-btn" onClick={handleSwitch}>
          {t(state)} <i className={`arrow-icon active ${condition}`}></i>
        </div>
        <div className={`drop-down-box-wrapper user-dropdown ${condition}`}>
          <div className="drop-down-box">
            {list &&
              list.map((el) => (
                <p onClick={handleClick(el)} key={"dropdown" + el}>
                  {el}
                </p>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropDown;
